import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import hasPermission from '../../utils/hasMultiplePermission';

const SORDownloadModal = ({
	show,
	onHide,
	onDownload,
	onAddToProfile,
	downloadLoading = false,
	addToProfileLoading = false,
	initialShowFinal = false,
	initialIncludeAssessments = false,
	initialExcludeGrade = false,
}) => {
	const givenPermissions = useSelector((state) => state.givenPermission);
	const canAddToProfile = hasPermission({ scopes: ["add_generated_sor_to_student_profile"], permissions: givenPermissions?.givenPermission ?? givenPermissions });

	const [isShowFinal, setIsShowFinal] = useState(initialShowFinal);
	const [isIncludeAssessments, setIsIncludeAssessments] = useState(initialIncludeAssessments);
	const [isExcludeGrade, setIsExcludeGrade] = useState(initialExcludeGrade);

	useEffect(() => {
		if (show) {
			setIsShowFinal(initialShowFinal);
			setIsIncludeAssessments(initialIncludeAssessments);
			setIsExcludeGrade(initialExcludeGrade);
		}
	}, [show, initialShowFinal, initialIncludeAssessments, initialExcludeGrade]);

	const toggleItems = [
		{ label: 'Show Final Results', value: isShowFinal, onChange: setIsShowFinal },
		{ label: 'Include Assessments', value: isIncludeAssessments, onChange: setIsIncludeAssessments },
		{ label: 'Exclude Empty Grades', value: isExcludeGrade, onChange: setIsExcludeGrade },
	];

	const handleAction = (callback) => {
		if (callback) {
			callback({ isShowFinal, isIncludeAssessments, isExcludeGrade });
		}
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			dialogClassName="sor-modal-dialog"
			contentClassName="sor-modal-content"
		>
			<div className="sor-modal-body">
				<div className="sor-modal-header">
					<h4 className="sor-modal-title">Statement of Results</h4>
					<button
						type="button"
						className="sor-modal-close"
						onClick={onHide}
						aria-label="Close"
					>
						<i className="fal fa-times"></i>
					</button>
				</div>

				<p className="sor-modal-description">
					This generates the statement of results for student grades. Add to Student Profile saves the SOR to the student's Certificates tab.
				</p>

				<div className="sor-toggles-container">
					{toggleItems.map((item, idx) => (
						<div key={idx} className="sor-toggle-card">
							<span className="sor-toggle-label">{item.label}</span>
							<div className="toggle-switch ml-2">
								<label className="switch mb-0">
									<input
										type="checkbox"
										checked={item.value}
										onChange={(e) => item.onChange(e.target.checked)}
									/>
									<span className="slider slider-round"></span>
								</label>
							</div>
						</div>
					))}
				</div>

				<div className="sor-actions-container">
					<button
						type="button"
						className="btn btn-primary"
						disabled={downloadLoading || addToProfileLoading}
						onClick={() => handleAction(onDownload)}
					>
						{downloadLoading ? (
							<i className="fas fa-spinner fa-spin mr-2"></i>
						) : (
							<i className="fal fa-download mr-2"></i>
						)}
						Download
					</button>

					{/* {canAddToProfile && ( */}
						<button
							type="button"
							className="btn btn-primary"
							disabled={downloadLoading || addToProfileLoading}
							onClick={() => handleAction(onAddToProfile)}
						>
							{addToProfileLoading ? (
								<i className="fas fa-spinner fa-spin mr-2"></i>
							) : (
								<i className="fal fa-user mr-2"></i>
							)}
							Add to Student Profile
						</button>
					{/* // )} */}

					<button
						type="button"
						className="btn btn-danger"
						disabled={downloadLoading || addToProfileLoading}
						onClick={onHide}
					>
						<i className="fal fa-times mr-2"></i>
						Cancel
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default SORDownloadModal;
